import '@mathflat/design-system-2024/variables.css'

import { fontFamily } from '@design-system/styles/fontFamily'
import { css, Global } from '@emotion/react'
import styles, { resetCSS, typo, zIndex } from '@mathflat/common/style'

import { fonts } from './font'

const {
  colors: { gray },
} = styles

const GlobalStyle = () => {
  return (
    <Global
      styles={css`
        ${fonts};
        ${resetCSS};

        // 매쓰플랫 선생님앱은 정의된 화면 밖으로 스크롤 시키지 않는다.
        overflow: hidden;

        [role='button'] {
          cursor: pointer;
        }

        :where(*:not(text)) {
          ${fontFamily.pretendard};
          box-sizing: border-box;
          -webkit-tap-highlight-color: rgba(0, 0, 0, 0.05);
          -webkit-text-size-adjust: none;
        }

        html {
          height: 100%;
        }

        #root {
          display: flex;
          min-height: 600px;
          flex-direction: column;
          height: 100%;
        }

        body {
          height: 100%;
          min-height: 100%;
          margin: 0;
          padding: 0;
          border: 0;
          ${fontFamily.pretendard};
          font-weight: 400;
          ${typo.body02};
        }

        button {
          margin: 0;
          padding: 0;
          border: none;
          outline: none;
          font-size: 14px;
          background: transparent;
          cursor: pointer;
          ${fontFamily.pretendard};
        }

        a {
          color: inherit;
          text-decoration: none;
        }

        ::placeholder {
          ${fontFamily.pretendard};
          color: ${gray.$500};
        }
        input::-webkit-input-placeholder {
          ${fontFamily.pretendard};
        }

        textarea {
          ${fontFamily.pretendard};
        }

        .rc-tooltip {
          position: absolute !important;
          z-index: ${zIndex.RCTooltip};
        }
        .rc-tooltip-inner.hide {
          visibility: hidden;
        }
      `}
    />
  )
}

export default GlobalStyle
